<template>
    <header id="header" class="tra-menu white-scroll">
        <div class="header-wrapper">
            <HeaderHilltopLogo />
            <HeaderHilltopMenu />
        </div>
    </header>
</template>
